import { render, staticRenderFns } from "./AffiliatesLegal.vue?vue&type=template&id=d704ba78&"
import script from "./AffiliatesLegal.vue?vue&type=script&lang=js&"
export * from "./AffiliatesLegal.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatesLegal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d704ba78')) {
      api.createRecord('d704ba78', component.options)
    } else {
      api.reload('d704ba78', component.options)
    }
    module.hot.accept("./AffiliatesLegal.vue?vue&type=template&id=d704ba78&", function () {
      api.rerender('d704ba78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/affiliates/AffiliatesLegal.vue"
export default component.exports